export function selectionSetCaret(
  contentEl: HTMLDivElement | null,
  offset = 0,
): void {
  if (!contentEl) {
    return;
  }

  const range = document.createRange();
  const sel = window.getSelection();

  contentEl.focus();

  const textNode = contentEl.firstChild;

  if (!textNode || !sel) {
    return;
  }

  range.setStart(textNode, offset);
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
}
